import { render, staticRenderFns } from "./flotilla.vue?vue&type=template&id=2441b594&scoped=true"
import script from "./flotilla.vue?vue&type=script&lang=js"
export * from "./flotilla.vue?vue&type=script&lang=js"
import style0 from "./flotilla.vue?vue&type=style&index=0&id=2441b594&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2441b594",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VButton: require('/var/www/tubber-new/components/global/v/button.vue').default,VBreadcrumbs: require('/var/www/tubber-new/components/global/v/breadcrumbs.vue').default,VCarousel: require('/var/www/tubber-new/components/global/v/carousel.vue').default,VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default,RequestAction: require('/var/www/tubber-new/components/global/RequestAction.vue').default,VFullsizeGallery: require('/var/www/tubber-new/components/global/v/fullsize-gallery.vue').default})
